"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetDiscounts = void 0;
const promotions_context_1 = require("./promotions.context");
const promotions_utils_1 = require("./promotions.utils");
/**
 * Hook that wraps the getDiscounts util function with the promotional data from the context
*/
const useGetDiscounts = () => {
    const promotionData = (0, promotions_context_1.usePromotionsData)();
    /**
     * @param {Array<{ sku: String, parentSku: String, quantity: Number, category: String, price: Number}>} selectedProducts
     * @param {{ roundDiscount: Boolean }} options
    */
    const getDiscounts = (selectedProducts = [], options = {}) => {
        return (0, promotions_utils_1.getDiscounts)(promotionData, selectedProducts, options);
    };
    return { getDiscounts };
};
exports.useGetDiscounts = useGetDiscounts;
//# sourceMappingURL=promotions.hooks.js.map